<template>
  <div class="verify-phone">
    <div class="logo">
      <img class="logo-img" src="@/assets/newApply/etc-logo.png" alt="">
    </div>
    <div class="tips-box">
      <ul class="tips-ul">
        <li>
          若你填写的手机号码已经在ETC助手上有未完成的订单，则可以登录后继续进行办理。
        </li>
        <li>
          若你填写的手机号码没有在ETC助手上有订单，则可以登录后免费领取。
        </li>
        <li>
          微信公众号/小程序【ETC助手】
        </li>
      </ul>
    </div>
    <div class="form">
      <div class="field">
        <div class="label">
          手机号
        </div>
        <div class="input-wrap">
          <input maxlength="11" placeholder="请输入手机号码" v-model="phone" type="tel" class="input" />
        </div>
      </div>
      <div class="field">
        <div class="label">
          验证码
        </div>
        <div class="input-wrap">
          <input maxlength="4" placeholder="请输入手机验证码" type="tel" v-model="verifyCode" class="input" />
        </div>
        <div @click="onClickSendSMSCode" class="act-link" :class="{'act-link__disabeld':sendSMSCodeDelay||!isValidPhoneNumber}">
          {{sendSMSCodeDelay?sendSMSCodeDelay+'秒后重发':'获取验证码'}}
        </div>
      </div>
    </div>
    <div class="bottom-fixed">
      <button @click="onClickNextBtn" :disabled="!isValidForm" class="btn">
        下一步
      </button>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user.api'

import ETC from '@/config/etc.config'
// mixin
import FunMixin from '@/mixins/funMixin'

// utils
import ETCUtil from '@/utils/util.etc'

export default {
  methods: {
    sendSMSCodeCountdown() {
      setTimeout(() => {
        this.sendSMSCodeDelay--
        if (this.sendSMSCodeDelay > 0) {
          this.sendSMSCodeCountdown()
        }
      }, 1000)
    },
    onClickSendSMSCode() {
      if (this.sendSMSCodeDelay === 0 && this.isValidPhoneNumber) {
        this.sendSMSCodeDelay = 60
        userApi.postSendPhoneVerificationCode(this.phone).then(
          res => {
            this.sendSMSCodeCountdown()
          },
          err => {
            this.m_showToast('发送短信验证码失败，请稍候再试')
            this.sendSMSCodeDelay = 0

            console.error(err)
          }
        )
      }
    },
    onClickNextBtn() {
      if (this.isValidForm) {
        userApi.loginByPhone(this.phone, this.verifyCode).then(
          res => {
            // localStorage.setItem(ETC.LOCAL_STORAGE_KEY.TOKEN, res.token)
            console.log(res)
            ETCUtil.setToken(res.token)
            localStorage.setItem(ETC.LOCAL_STORAGE_KEY.ETC_UID, res.uid)
            localStorage.setItem(ETC.LOCAL_STORAGE_KEY.LOGIN_PHONE, this.phone)
            if (this.redirect) {
              this.$router.replace(this.redirect)
            } else if (this.callback) {
              this.$eventBus.$emit('onLogin', true)
            } else {
              this.$router.replace('/')
            }
          },
          err => {
            if (err.code === 1001 || err.code === 1002) {
              this.m_showToast('短信验证码错误')
            }
          }
        )
      }
    }
  },
  created() {
    this.redirect = this.$route.query.redirect
    this.callback = this.$route.query.callback
    ETCUtil.clearToken()
  },
  data: () => ({
    sendSMSCodeDelay: 0,
    phone: '',
    verifyCode: ''
  }),
  computed: {
    isValidPhoneNumber() {
      return /^1\d{10}$/.test(this.phone)
    },
    isValidForm() {
      return this.isValidPhoneNumber && this.verifyCode.length === 4
    }
  },
  mixins: [FunMixin]
}
</script>

<style lang="scss" scoped>
.logo {
  text-align: center;
  padding-top: 60px;
  .logo-img {
    margin: 0 auto;
    display: block;
    width: 280px;
    height: 60px;
  }
}

.tips-box {
  background: rgba(238, 238, 238, 0.5);
  padding: 20px;
  margin: 60px 40px;
  border-radius: 10px;
  .tips-ul {
    padding-left: 40px;
    li {
      font-size: 28px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 1.6;
      list-style: disc;
    }
  }
}

.form {
  margin: 0 40px;
  .field {
    border-bottom: 1px solid #eeeeee;
    display: flex;
    height: 100px;
    overflow: hidden;
    align-items: center;
    .label {
      color: #333333;
      font-size: 32px;
    }
    .input-wrap {
      padding-left: 40px;
      flex: 1;
      .input {
        width: 100%;
        margin: 0;
        padding: 0;
        border: none;
        background: none;
        font-size: 32px;
        height: 42px;
        &::placeholder {
          font-size: 32px;
        }
      }
    }
    .act-link {
      padding-left: 40px;
      color: #0094ee;
      font-size: 30px;
    }
    .act-link__disabeld {
      color: #aaa;
    }
  }
}
.bottom-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 30px 55px;
  .btn {
    height: 90px;
    // background: rgba(221, 221, 221, 1);
    width: 100%;
    background: linear-gradient(
      180deg,
      rgba(13, 226, 164, 1) 0%,
      rgba(21, 195, 195, 1) 100%
    );
    box-shadow: 0px 6px 12px 0px rgba(12, 161, 147, 0.35);
    border-radius: 75px;
    font-size: 36px;
    color: #fff;
  }
  .btn[disabled] {
    background: #dddddd;
    box-shadow: none;
  }
}
</style>
